
export default {
  name: 'BannerSimple',

  props: {
    image: {
      type: Number,
      default: null,
    },
    title: {
      type: String,
      default: '',
    },
  },

  computed: {
    bannerImage: function () {
      return this.image ? this.image : "";
    },
    bannerTitle: function () {
      return this.title ? String(this.title) : "Наша команда";
    }
  }
}
